import React, { useState, useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import logoImage from "images/rocks/rocky_green.svg";

const TicketContainer = tw.div`flex flex-col items-center`;

const CardWrapper = styled.div`
  ${tw`relative`}
  width: 295px;
  height: 175px;
  perspective: 1000px;
`;

const Card = styled.div`
  ${tw`w-full h-full`}
  position: relative;
  z-index: 1;
  transition: transform 0.8s;
  transform-style: preserve-3d;
  ${({ flipped }) => flipped && "transform: rotateY(180deg);"}
`;

const CardFace = styled.div`
  ${tw`absolute w-full h-full rounded-2xl shadow-2xl`}
  backface-visibility: hidden;
  display: flex;
  align-items: center;
  padding: 1.5rem;
  box-sizing: border-box;
`;

const CardFront = styled(CardFace)`
  ${tw`bg-purple-400`}
`;

const CardBack = styled(CardFace)`
  ${tw`bg-purple-400 justify-center text-center`}
  transform: rotateY(180deg);
`;

const TicketLeft = tw.div`pr-5`;

const TicketSite = styled.span`
  ${tw`text-gray-900`}
  font-family: 'Indie Flower', cursive;
  font-size: 2rem;
`;

const TicketQR = tw.img``;

const TicketId = styled.div`
  position: absolute;
  right: 1rem;
  top: 0.8rem;
  font-size: 0.8rem;
`;

const DiscountWrapper = styled.div`
  ${tw`absolute w-full h-full pointer-events-none`}
  top: 0;
  left: 0;
  transform-style: preserve-3d;
  transition: transform 0.8s;
  z-index: 2;

  ${({ flipped }) => flipped && "transform: rotateY(180deg);"}
`;

const DiscountBase = styled.div`
  ${tw`absolute bg-red-400 text-gray-900 font-bold flex items-center justify-center shadow-lg text-center`}
  width: 56px;
  height: 26px;
  font-size: 1.1rem;
  backface-visibility: hidden;
  color: white;
  z-index: 2;
  &:before {
    content: "";
    position: absolute;
    left: -26px;
    top: -26px;
    width: 0;
    height: 0;
    border-left: 26px solid transparent;
    border-top: 26px solid transparent;
    border-bottom: 26px solid rgb(252 129 129 / var(--tw-bg-opacity));
  }
  &:after {
    content: "";
    position: absolute;
    left: 56px;
    top: -26px;
    width: 0;
    height: 0;
    border-right: 26px solid transparent;
    border-top: 26px solid transparent;
    border-bottom: 26px solid rgb(252 129 129 / var(--tw-bg-opacity));
  }
`;

const DiscountFront = styled(DiscountBase)`
  top: 16px;
  left: 1px;
  transform: rotate(-45deg);
`;

const DiscountBack = styled(DiscountBase)`
  top: 16px;
  right: 1px;
  transform: rotateY(180deg) rotate(-45deg);
`;


export default function TicketComponent({ ticket = null, onlyFront = false }) {
  const [flipped, setFlipped] = useState(false);
  const touchStartX = useRef(null);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (onlyFront) return;
    const touchEndX = e.changedTouches[0].clientX;
    const diff = touchEndX - touchStartX.current;
    if (Math.abs(diff) > 50) {
      setFlipped(prev => !prev); // Flip on swipe left or right
    }
  };

  return (
    <TicketContainer>
      <CardWrapper
        onClick={() => !onlyFront && setFlipped(!flipped)}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        {ticket?.discount?.percent && (
          <DiscountWrapper flipped={flipped}>
            <DiscountFront>
              -{ticket.discount.percent}<small>%</small>
            </DiscountFront>

            <DiscountBack>
              -{ticket.discount.percent}<small>%</small>
            </DiscountBack>
          </DiscountWrapper>
        )}
        <Card flipped={flipped}>
          {/* Front Side */}
          <CardFront>
            <TicketLeft>
              <img alt="Logo" width="110" src={logoImage} />
            </TicketLeft>
            <TicketQR
              download={`${ticket.id}.png`}
              src={ticket.qr.replace(/;base64/, `;name=${ticket.id}.png;base64`)}
            />
          </CardFront>

          {/* Back Side */}
          {!onlyFront && (
            <CardBack>
              <TicketId>#{ticket.id}</TicketId>
              <TicketSite>cozyrock.kz</TicketSite>
            </CardBack>
          )}
        </Card>
      </CardWrapper>
    </TicketContainer>
  );
}